/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState } from 'react';
import { registerLocale } from 'react-datepicker';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import InputMask from 'react-input-mask';
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import es from 'date-fns/locale/es';
import ca from 'date-fns/locale/ca';
import de from 'date-fns/locale/de';
import en from 'date-fns/locale/en-US';
import eu from 'date-fns/locale/eu';
import gl from 'date-fns/locale/gl';
import {
  FamiliarData,
  PersonalData,
  PrefijoPais,
  TiposDocumento,
} from '../../../types/PersonalData';
import DataService from '../../../services/MisDatosService';
import { useAuthStore as useAuthStoreEroski } from '../../../store/AuthContext';
import useAPIError from '../../../hooks/useAPIError';
import { useAppStore } from '../../../store/AppContext';
import { StorageHelper } from '../../../utils/StorageHelper';
import { MisDatosHelper } from '../MisDatosHelper';
import { MisDatosConstants } from '../../../utils/MisDatosConstants';
import ModalConfirmacion from '../../../components/ModalConfirmacion';
import { CookieHelper } from '../../../utils/CookieHelper';
import { ErrorCodeConstants } from '../../../utils/ErrorCodeConstants';
import { TextHelper } from '../../../utils/TextHelper';
import EroskiDatePicker from '../../../components/EroskiDatePicker';
import ServicioSms from '../servicioSms';
import IconBack from '../../../Icons/IconBack';
import IconChat from '../../../Icons/IconChat';
import CapraboDatePicker from '../../../components/CapraboDatePicker';
import { HostProvider } from '../../../utils/HostProvider';
import ModalContactConfirmacion from '../../../components/ModalContactConfirmacion';

interface Props {
  personalData: PersonalData;
  setPersonalData: (personalData: PersonalData) => void;
  setFamiliarData: (familiarData: FamiliarData) => void;
  familiarData: FamiliarData;
  isFamilyData: boolean;
  visible: boolean;
  setShow: (show: boolean) => void;
  cargarPersonalData: () => void;
  cargarFamiliarData: () => void;
  cargarAccessData: () => void;
  prefijosPaises: PrefijoPais[];
  tiposDocumento: TiposDocumento[];
}

const DatosForm: FC<Props> = (props) => {
  const {
    personalData,
    setPersonalData,
    setFamiliarData,
    familiarData,
    isFamilyData,
    visible,
    setShow,
    cargarPersonalData,
    cargarFamiliarData,
    cargarAccessData,
    prefijosPaises,
    tiposDocumento,
  } = props;
  const dataUser = useAuthStoreEroski();
  const { t } = useTranslation();
  const { addError, addErrorBack, addWarning } = useAPIError();
  const [bornDate, setBorndate] = useState<string>(
    moment().format('YYYY-MM-DD'),
  );
  const [terminateDate, setTerminatedate] = useState<string>(
    moment().add(1, 'days').format('YYYY-MM-DD'),
  );
  const [endTerminateDate, setEndTerminatedate] = useState<string>(
    moment().add(5, 'years').format('YYYY-MM-DD'),
  );
  const opcion = 'datosPersonales' as string;
  const [view, setView] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [doSubmit, setDoSubmit] = useState<boolean>(false);
  const [resetdoSubmit, setResetDoSubmit] = useState<boolean>(false);
  const [errorBornDate, setErrorBornDate] = useState<boolean>(false);
  const [errorCarnet, setErrorCarnet] = useState<boolean>(false);
  const [errorTerminateDate, setErrorTerminateDate] = useState<boolean>(false);
  const [errorGenero, setErrorGenero] = useState<boolean>(false);
  const [isAditional, setIsAditional] = useState<boolean>(false);
  const [isTitular, setIsTitular] = useState<boolean>(false);
  const [isValidFamilia, setIsValidFamilia] = useState<boolean>(false);
  const [startSmsService, setStartSmsService] = useState<boolean>(false);
  const [backPersonalData, setBackPersonalData] = useState<PersonalData>(
    personalData,
  );
  const [backFamiliarData, setBackFamiliarData] = useState<FamiliarData>(
    familiarData,
  );
  const [emailContactoCambiado, setEmailContactoCambiado] = useState<boolean>(
    false,
  );
  const [ShowErrorSinTransicion, setShowErrorSinTransicion] = useState<boolean>(
    false,
  );
  const [showCancelButton, setShowCancelButton] = useState<boolean>(false);
  const isApp = dataUser.user.isApp === 'true';
  // Telefono movil
  const [telfMovil, setTelfMovil] = useState<string>('');
  const [prefijoMovil, setPrefijoMovil] = useState<string>('');
  const [tamTelfMovil, setTamTelfMovil] = useState<number>(9);
  const [readyMainPhone, setReadyMainPhone] = useState<boolean>(false);
  // Telefono secundario
  const [prefijoSec, setPrefijoSec] = useState<string>('');
  const [tamTelfSec, setTamTelfSec] = useState<number>(9);
  const [readySeconPhone, setReadySeconPhone] = useState<boolean>(false);
  const [textForModalCambioEmail, setTextForModalCambioEmail] = useState(
    '' as string,
  );
  const {
    register,
    handleSubmit,
    triggerValidation,
    errors,
    control,
    formState: { isSubmitting },
    reset,
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
  });
  const dataApp = useAppStore();
  const isEroski = HostProvider.isEroski();
  const idiomas = isEroski
    ? MisDatosConstants.TODOS_IDIOMAS_EROSKI
    : MisDatosConstants.TODOS_IDIOMAS_CAPRABO;
  const title = t('datos.personaldata.modal-email-confirmacion-title');
  const text1 = t('datos.personaldata.modal-email-confirmacion-message1');
  const text2 = t('datos.personaldata.modal-email-confirmacion-message2');
  const [errorTitulo, setErrorTitulo] = useState<string>('');
  const [errorMensaje, setErrorMensaje] = useState<string>('');
  const [isInfoFamily, setIsFamilyInfo] = useState<boolean>(
    familiarData.esFamiliaNumerosa,
  );
  const acceptButtonTextKey = t('entendido');
  const cancelContactButtonTextKey = t('datos.accessdata.cancelar');
  const acceptContactButtonTextKey = t(
    'guardarMisDatos-invalidDoc-incorrect-button',
  );
  const misDatosHelper = new MisDatosHelper();
  const [isFullPrefijoPrincipal, setIsFullPrefijoPrincipal] = useState<boolean>(
    false,
  );
  const [isFullPrefijoSec, setIsFullPrefijoSec] = useState<boolean>(false);

  const handleChangeBornDate = (date: Date) => {
    const fecha = moment(date);
    setBorndate(fecha.format('YYYY-MM-DD'));
    setPersonalData({
      ...personalData,
      fechaNacimiento: fecha.format('DD/MM/YYYY'),
    });
    const isValidFecha = misDatosHelper.checkValidFecha(
      fecha.format('YYYY-MM-DD'),
    );
    setErrorBornDate(!isValidFecha);
  };

  const handlerCarnetChange = (value: string, maxcarnet: number) => {
    // eslint-disable-next-line default-case
    const isValid = misDatosHelper.testCarnet(value, maxcarnet, false);
    setErrorCarnet(!isValid);
    setFamiliarData({
      ...familiarData,
      numeroCarnet: value,
    });
  };

  const handleChangeTerminateDate = (date: Date) => {
    const fecha = moment(date);
    setTerminatedate(fecha.format('YYYY-MM-DD'));
    setFamiliarData({
      ...familiarData,
      fechaCaducidad: fecha.format('DD/MM/YYYY'),
    });
    const isValidFecha = misDatosHelper.checkTerminateValidFecha(
      fecha.format('YYYY-MM-DD'),
    );
    setErrorTerminateDate(!isValidFecha);
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const emptymethod = () => {};

  const ducplicateDocumentEvent = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    document.getElementById('datos-personales-back').click();
    const url = isEroski
      ? `${process.env.REACT_APP_SERVER_EROSKI_ES}${t('link.contacto')}`
      : `${process.env.REACT_APP_CLUB_CAPRABO}${t('link.ccTitle')}`;
    document.location.href = url;
  };

  const cancelButtonEvent = () => {
    setShowErrorSinTransicion(false);
  };

  const handleChangeGenero = (genre: string) => {
    setPersonalData({
      ...personalData,
      genero: genre,
    });
    misDatosHelper.validarGenero(setErrorGenero);
  };

  const handlerChange = (value: React.ChangeEvent<HTMLInputElement>) => {
    // eslint-disable-next-line default-case
    setIsFamilyInfo(value.target.checked);
    setFamiliarData({
      ...familiarData,
      esFamiliaNumerosa: value.target.checked,
    });
    // Validate carnet
    if (value.target.checked) {
      const isValid = misDatosHelper.testCarnet(
        familiarData.numeroCarnet,
        MisDatosConstants.MAX_LENGTH_CARNE,
        false,
      );
      setErrorCarnet(!isValid);
    } else {
      setErrorCarnet(value.target.checked);
      setFamiliarData({
        ...familiarData,
        fechaCaducidad: '',
        esFamiliaNumerosa: false,
        numeroCarnet: '',
      });
    }
  };

  const validarTipoDni = (value: any) => {
    const { tipoDocumento } = personalData;
    return personalData.dniEditable
      ? misDatosHelper.validarTipoDni(value, tipoDocumento)
      : true;
  };

  const prepararCamposDeTelefonosVacios = () => {
    if (personalData.prefijoTelefono === null && prefijosPaises[0]) {
      setPrefijoMovil(prefijosPaises[0].prefijo);
      setTamTelfMovil(prefijosPaises[0].tamanioTelefono);
      setReadyMainPhone(true);
      setIsFullPrefijoPrincipal(true);
    }
    if (personalData.prefijoTelefonoSecundario === null && prefijosPaises[0]) {
      setPrefijoSec(prefijosPaises[0].prefijo);
      setTamTelfSec(prefijosPaises[0].tamanioTelefono);
      setReadySeconPhone(true);
      setIsFullPrefijoSec(true);
    }
  };

  const prepararCamposDeTelefonosInformados = () => {
    prefijosPaises.forEach((currentValue) => {
      if (currentValue.id.toString() === personalData.prefijoTelefono) {
        setPrefijoMovil(currentValue.prefijo);
        setTamTelfMovil(currentValue.tamanioTelefono);
        setReadyMainPhone(true);
        setIsFullPrefijoPrincipal(true);
      }
      if (
        currentValue.id.toString() === personalData.prefijoTelefonoSecundario
      ) {
        setPrefijoSec(currentValue.prefijo);
        setTamTelfSec(currentValue.tamanioTelefono);
        setReadySeconPhone(true);
        setIsFullPrefijoSec(true);
      }
    });
  };

  const validarFechaNacimiento = () => {
    if (
      typeof personalData !== 'undefined' &&
      personalData.fechaNacimiento !== ''
    ) {
      if (typeof personalData.fechaNacimiento !== 'undefined') {
        const bornDateFormated = moment(
          personalData.fechaNacimiento ?? new Date(),
          'DD/MM/YYYY',
        ).format('YYYY-MM-DD');
        setBorndate(bornDateFormated);
        const isValidFecha = misDatosHelper.checkValidFecha(bornDateFormated);
        setErrorBornDate(!isValidFecha);
      }
    }
  };

  const validarFamiliaNumerosa = (isfamilia: boolean) => {
    setIsValidFamilia(isfamilia);
    setIsAditional(dataUser.user.adicional || false);
    setIsTitular(dataUser.user.titular || false);
  };

  const gestionTelefonoSecundario = () => {
    const prefSec = misDatosHelper.comprobarPrefijoSecundario();
    if (prefSec === null) {
      personalData.telefonoSecundario = '';
      personalData.prefijoTelefonoSecundario = null;
    } else {
      personalData.prefijoTelefonoSecundario = prefSec.toString();
    }
  };

  const hideForm = () => {
    setShow(false);
    document.body.classList.remove('fix');
    setPersonalData(backPersonalData);
    setFamiliarData(backFamiliarData);
    setTerminatedate(moment().add(1, 'days').format('YYYY-MM-DD'));
    const formulario = document.getElementById(
      'form-datos-personales',
    ) as HTMLFormElement;
    formulario.reset();
    reset();
  };

  const UpdatePersonalData = () => {
    const isValidGenero = misDatosHelper.validarGenero(setErrorGenero);
    const isValidFecha = misDatosHelper.checkValidFecha(bornDate);
    personalData.fromApp = isApp ? 'app_club' : 'web';
    let isValidCarnet = true;
    let isTerminateValidFecha = true;

    // Family Validations
    if (isInfoFamily && isTitular && !isAditional) {
      isValidCarnet = misDatosHelper.testCarnet(
        familiarData.numeroCarnet,
        MisDatosConstants.MAX_LENGTH_CARNE,
        true,
      );
      setErrorCarnet(!isValidCarnet);
      isTerminateValidFecha = isInfoFamily
        ? misDatosHelper.checkTerminateValidFecha(terminateDate)
        : true;
    }

    if (
      (personalData.tipoUsuario !== MisDatosConstants.ID_TIPO_USUARIO_EMPRESA &&
        isValidFecha &&
        isValidCarnet &&
        isTerminateValidFecha &&
        isValidGenero) ||
      (personalData.tipoUsuario === MisDatosConstants.ID_TIPO_USUARIO_EMPRESA &&
        isValidCarnet &&
        isTerminateValidFecha)
    ) {
      personalData.tipoCambioMail = 'MD'; // Origen cambio de email form update personal data
      gestionTelefonoSecundario();
      StorageHelper.deleteUserFromSession();
      CookieHelper.removeUserCookies();
      DataService.updatePersonalData(
        personalData,
        misDatosHelper.switchTipoUsuario(personalData.tipoUsuario),
      )
        .then((response) => {
          if (response.data.error === true) {
            if (
              response.data.errorCode ===
                ErrorCodeConstants.GUARDAR_MISDATOS_TIPODOC_EXCEPTION ||
              response.data.errorCode ===
                ErrorCodeConstants.GUARDAR_MISDATOS_TECDOC_EXCEPTION
            ) {
              setShowCancelButton(
                response.data.errorCode ===
                  ErrorCodeConstants.GUARDAR_MISDATOS_TIPODOC_EXCEPTION,
              );
              setErrorTitulo(
                response.data.errorCode ===
                  ErrorCodeConstants.GUARDAR_MISDATOS_TECDOC_EXCEPTION
                  ? ''
                  : t(
                      TextHelper.getErrorTitleKeyTransformed(
                        response.data.title,
                      ),
                    ),
              );
              setErrorMensaje(
                t(
                  TextHelper.getErrorMessageKeyTransformed(
                    response.data.userMessage,
                  ),
                  { appname: isEroski ? 'EROSKI' : 'CAPRABO' },
                ),
              );
              setShowErrorSinTransicion(true);
            } else if (
              response.data.errorCode ===
              ErrorCodeConstants.UPDATE_DATOSACCESO_EMAIL_CORPORATION
            ) {
              addWarning(t('validaciones.corporative-mail'));
            } else {
              addErrorBack(response.data);
            }
          } else {
            if (isFamilyData && isInfoFamily && isTitular && !isAditional) {
              DataService.updateFamiliarData(familiarData).then(
                (responseBajaServicio) => {
                  if (responseBajaServicio.data.error === true) {
                    addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
                  }
                  cargarFamiliarData();
                },
              );
            }
            // Personal Data
            if (
              response.data.codeResponse ===
              MisDatosConstants.UPDATE_PERSONALES_OK_ACTIVAR_SMS
            ) {
              const data = {
                fromApp: isApp ? 'app_club' : 'web',
                dobleVerificacion: false,
              };
              DataService.updateDatosAcceso(data).then(
                (responseBajaServicio) => {
                  if (responseBajaServicio.data.error === false) {
                    cargarAccessData();
                    setStartSmsService(true);
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    document.getElementById('datos-personales-back').click();
                  } else {
                    addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
                  }
                },
              );
            }
            if (personalData.emailContacto !== backPersonalData.emailContacto) {
              setTextForModalCambioEmail(t(text1) + t(text2));
              personalData.emailContacto = backPersonalData.emailContacto;
              setEmailContactoCambiado(true);
            }
            setBackPersonalData(personalData);
            if (isFamilyData) {
              setBackFamiliarData(familiarData);
            }
            cargarPersonalData();
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            document.getElementById('datos-personales-back').click();
          }
        })
        .catch((er: any) => {
          console.log(er);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        });
    }
  };

  useEffect(() => {
    if (resetdoSubmit) {
      setDoSubmit(true);
      setResetDoSubmit(false);
    }
  }, [resetdoSubmit]);

  useEffect(() => {
    if (visible && doSubmit && readyMainPhone && readySeconPhone) {
      StorageHelper.removeOpenPersonalData();
      setDoSubmit(false);
      setReadyMainPhone(false);
      setReadySeconPhone(false);
      misDatosHelper.validarGenero(setErrorGenero);
      validarFechaNacimiento();
      const element = document.getElementById(
        'datos-personales-submit-btn',
      ) as HTMLElement;
      element.click();
    } else {
      // eslint-disable-next-line no-lonely-if
      if (doSubmit) {
        prepararCamposDeTelefonosInformados();
        prepararCamposDeTelefonosVacios();
        setDoSubmit(false);
        setResetDoSubmit(true);
      }
    }
  }, [doSubmit]);

  useEffect(() => {
    setDisabled(!personalData.dniEditable);
    if (visible) {
      misDatosHelper.validarGenero(setErrorGenero);
      validarFechaNacimiento();
      prepararCamposDeTelefonosInformados();
      prepararCamposDeTelefonosVacios();
      setIsFamilyInfo(familiarData.esFamiliaNumerosa);
      validarFamiliaNumerosa(familiarData.esFamiliaNumerosa);

      if (familiarData.esFamiliaNumerosa && isTitular && !isAditional) {
        toast.dismiss();
        toast.error(t('datos.personaldata.modal-family-confirmacion-message'), {
          duration: 3000,
          style: {
            border: '1px solid #04488e',
            padding: '16px',
            color: '#04488e',
          },
          iconTheme: {
            primary: '#04488e',
            secondary: '#e5e9ed',
          },
        });
      }
      if (StorageHelper.isOpenPersonalData()) {
        setDoSubmit(true);
      }
      if (StorageHelper.getOpenOroPersonalData()) {
        StorageHelper.removeOpenOroPersonalData();
        setDoSubmit(true);
        const element = document.getElementById(
          'datos-personales-submit-btn',
        ) as HTMLElement;
        element.click();
      }
    }
  }, [visible]);

  useEffect(() => {
    switch (dataApp.lang) {
      case 'de':
        registerLocale('lang', de);
        moment.locale('de');
        break;
      case 'ca':
        registerLocale('lang', ca);
        moment.locale('ca');
        break;
      case 'en':
        registerLocale('lang', en);
        moment.locale('en');
        break;
      case 'eu':
        registerLocale('lang', eu);
        moment.locale('eu');
        break;
      case 'gl':
        registerLocale('lang', gl);
        moment.locale('gl');
        break;
      default:
        registerLocale('lang', es);
        moment.locale('es');
    }
  }, [dataApp.lang]);

  useEffect(() => {
    setEndTerminatedate(moment().add(5, 'y').format('YYYY-MM-DD'));

    setBackPersonalData(personalData);
    if (isFamilyData) {
      setBackFamiliarData(familiarData);
    }
  }, [personalData.tipoUsuario]);

  useEffect(() => {
    if (!view) {
      setView(true);
    }
  }, [dataUser.user.token]);

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      const element = document.getElementById('section') as HTMLElement;
      element.removeEventListener('keydown', saveInfo, false);
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('datos-personales-submit-btn').click();
    }
  };
  useEffect(() => {
    const element = document.getElementById('section') as HTMLElement;
    if (visible && view) {
      element.setAttribute('tabindex', '0');
      element.focus();
      element.addEventListener('keydown', saveInfo, false);
    }
  }, [visible, view]);

  useEffect(() => {
    if (visible) {
      setIsFullPrefijoPrincipal(false);
      setIsFullPrefijoSec(false);
    }
  }, [visible]);

  useEffect(() => {
    if (!isFullPrefijoPrincipal || !isFullPrefijoSec) {
      prepararCamposDeTelefonosInformados();
      prepararCamposDeTelefonosVacios();
    }
  });

  return (
    <>
      {(() => {
        if (view) {
          return (
            <>
              <section
                id="section"
                className={`o-section--large form-datos bloque-form ${
                  visible ? 'visible' : ''
                }`}
              >
                <div className="container">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                  <a
                    id="datos-personales-back"
                    href="#personales"
                    onClick={() => {
                      hideForm();
                    }}
                    className="link-prev"
                  >
                    <div className="icon icon-medium">
                      <IconBack />
                    </div>
                    <p className="u-font-normal u-text-brand u-margin-left">
                      {t('datos.personaldata.back')}
                    </p>
                  </a>

                  <Toaster position="top-center" />

                  <form
                    id="form-datos-personales"
                    className="form-datos-list"
                    onSubmit={handleSubmit(() => {
                      UpdatePersonalData();
                      // document.body.classList.remove('fix');
                    })}
                  >
                    <fieldset>
                      <h2 className="bloque-datos__title u-text-brand">
                        <span className="divider__square brand-color" />
                        <span className="u-margin-right">
                          {personalData.tipoUsuario !== 2
                            ? t('datos.personaldata.heading')
                            : t('datos.personaldata.company-heading')}
                        </span>
                      </h2>

                      <div className="row u-margin-bottom">
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {personalData.tipoUsuario !== 2 ? (
                              <label htmlFor="nombre" className="control-label">
                                {t('datos.personaldata.name')}
                              </label>
                            ) : (
                              <label
                                htmlFor="razonSocial"
                                className="control-label"
                              >
                                {t('datos.personaldata.razonSocial')}
                              </label>
                            )}
                            {personalData.tipoUsuario !== 2 ? (
                              <div className="form-control-block">
                                <input
                                  type="text"
                                  className={`form-control ${
                                    errors.nombre ? 'error' : ''
                                  }`}
                                  name="nombre"
                                  id="nombre"
                                  maxLength={
                                    MisDatosConstants.MAX_LENGTH_NOMBRE
                                  }
                                  value={
                                    personalData.nombre
                                      ? personalData.nombre.toUpperCase()
                                      : ''
                                  }
                                  onChange={($event) => {
                                    setPersonalData({
                                      ...personalData,
                                      nombre: $event.target.value.toUpperCase(),
                                    });
                                  }}
                                  ref={register({
                                    required: true,
                                    validate: (value) =>
                                      TextHelper.testNombre(value),
                                  })}
                                />
                                {errors.nombre &&
                                  errors.nombre.type === 'required' && (
                                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                    <label
                                      id="nombre-error"
                                      className="error"
                                      htmlFor="nombre"
                                    >
                                      {t('validaciones.empty-value')}
                                    </label>
                                  )}
                                {errors.nombre &&
                                  errors.nombre.type === 'validate' && (
                                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                    <label
                                      id="nombre-error"
                                      className="error"
                                      htmlFor="nombre"
                                    >
                                      {t('validaciones.not-valid-value')}
                                    </label>
                                  )}
                              </div>
                            ) : (
                              <div className="form-control-block">
                                <input
                                  type="text"
                                  className={`form-control ${
                                    errors.razonSocial ? 'error' : ''
                                  }`}
                                  name="razonSocial"
                                  id="razonSocial"
                                  maxLength={
                                    MisDatosConstants.MAX_LENGTH_RAZON_SOCIAL
                                  }
                                  defaultValue={personalData.razonSocial}
                                  onChange={($event) => {
                                    setPersonalData({
                                      ...personalData,
                                      razonSocial: $event.target.value,
                                    });
                                  }}
                                  ref={register({
                                    required: true,
                                    validate: (value) =>
                                      TextHelper.testNombre(value),
                                  })}
                                />
                                {errors.razonSocial &&
                                  errors.razonSocial.type === 'required' && (
                                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                    <label
                                      id="razonSocial-error"
                                      className="error"
                                      htmlFor="razonSocial"
                                    >
                                      {t('validaciones.empty-value')}
                                    </label>
                                  )}
                                {errors.razonSocial &&
                                  errors.razonSocial.type === 'validate' && (
                                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                    <label
                                      id="razonSocial-error"
                                      className="error"
                                      htmlFor="razonSocial"
                                    >
                                      {t('validaciones.not-valid-value')}
                                    </label>
                                  )}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {personalData.tipoUsuario !== 2 ? (
                              <label
                                htmlFor="primerapellido"
                                className="control-label"
                              >
                                {t('datos.personaldata.lastName1')}
                              </label>
                            ) : (
                              <label
                                htmlFor="contactName"
                                className="control-label"
                              >
                                {t('datos.personaldata.contactName')}
                              </label>
                            )}
                            {personalData.tipoUsuario !== 2 ? (
                              <div className="form-control-block">
                                <input
                                  type="text"
                                  className={`form-control ${
                                    errors.primerapellido ? 'error' : ''
                                  }`}
                                  name="primerapellido"
                                  id="primerapellido"
                                  maxLength={
                                    MisDatosConstants.MAX_LENGTH_APELLIDO_1
                                  }
                                  value={
                                    personalData.apellido1
                                      ? personalData.apellido1.toUpperCase()
                                      : ''
                                  }
                                  onChange={($event) => {
                                    setPersonalData({
                                      ...personalData,
                                      apellido1: $event.target.value.toUpperCase(),
                                    });
                                  }}
                                  ref={register({
                                    required: true,
                                    validate: (value) =>
                                      TextHelper.testNombre(value),
                                  })}
                                />
                                {errors.primerapellido &&
                                  errors.primerapellido.type === 'required' && (
                                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                    <label
                                      id="primerapellido-error"
                                      className="error"
                                      htmlFor="primerapellido"
                                    >
                                      {t('validaciones.empty-value')}
                                    </label>
                                  )}
                                {errors.primerapellido &&
                                  errors.primerapellido.type === 'validate' && (
                                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                    <label
                                      id="primerapellido-error"
                                      className="error"
                                      htmlFor="primerapellido"
                                    >
                                      {t('validaciones.not-valid-value')}
                                    </label>
                                  )}
                              </div>
                            ) : (
                              <div className="form-control-block">
                                <input
                                  type="text"
                                  className={`form-control ${
                                    errors.contactName ? 'error' : ''
                                  }`}
                                  name="contactName"
                                  id="contactName"
                                  maxLength={
                                    MisDatosConstants.MAX_LENGTH_NOMBRE
                                  }
                                  value={
                                    personalData.nombre
                                      ? personalData.nombre.toUpperCase()
                                      : ''
                                  }
                                  onChange={($event) => {
                                    setPersonalData({
                                      ...personalData,
                                      nombre: $event.target.value.toUpperCase(),
                                    });
                                  }}
                                  ref={register({
                                    required: true,
                                    validate: (value) =>
                                      TextHelper.testNombre(value),
                                  })}
                                />
                                {errors.contactName &&
                                  errors.contactName.type === 'required' && (
                                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                    <label
                                      id="contactName-error"
                                      className="error"
                                      htmlFor="contactName"
                                    >
                                      {t('validaciones.empty-value')}
                                    </label>
                                  )}
                                {errors.contactName &&
                                  errors.contactName.type === 'validate' && (
                                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                    <label
                                      id="contactName-error"
                                      className="error"
                                      htmlFor="contactName"
                                    >
                                      {t('validaciones.not-valid-value')}
                                    </label>
                                  )}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group u-margin-bottom">
                            {personalData.tipoUsuario !== 2 ? (
                              <label
                                htmlFor="segundoapellido"
                                className="control-label"
                              >
                                {t('datos.personaldata.lastName2')}
                              </label>
                            ) : (
                              <label
                                htmlFor="contactApellido"
                                className="control-label"
                              >
                                {t('datos.personaldata.contactLastName1')}
                              </label>
                            )}
                            {personalData.tipoUsuario !== 2 ? (
                              <div className="form-control-block">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="segundoapellido"
                                  id="segundoapellido"
                                  maxLength={
                                    MisDatosConstants.MAX_LENGTH_APELLIDO_2
                                  }
                                  value={
                                    personalData.apellido2
                                      ? personalData.apellido2.toUpperCase()
                                      : ''
                                  }
                                  onChange={($event) => {
                                    setPersonalData({
                                      ...personalData,
                                      apellido2: $event.target.value.toUpperCase(),
                                    });
                                  }}
                                  ref={register({
                                    validate: (value) =>
                                      value !== null &&
                                      value !== '' &&
                                      value !== undefined
                                        ? TextHelper.testNombre(value)
                                        : true,
                                  })}
                                />
                                {errors.segundoapellido &&
                                  errors.segundoapellido.type ===
                                    'validate' && (
                                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                    <label
                                      id="segundoapellido-error"
                                      className="error"
                                      htmlFor="segundoapellido"
                                    >
                                      {t('validaciones.not-valid-value')}
                                    </label>
                                  )}
                              </div>
                            ) : (
                              <div className="form-control-block">
                                <input
                                  type="text"
                                  className={`form-control ${
                                    errors.contactApellido ? 'error' : ''
                                  }`}
                                  name="contactApellido"
                                  id="contactApellido"
                                  maxLength={
                                    MisDatosConstants.MAX_LENGTH_APELLIDO_1
                                  }
                                  value={
                                    personalData.apellido1
                                      ? personalData.apellido1.toUpperCase()
                                      : ''
                                  }
                                  onChange={($event) => {
                                    setPersonalData({
                                      ...personalData,
                                      apellido1: $event.target.value.toUpperCase(),
                                    });
                                  }}
                                  ref={register({
                                    required: true,
                                    validate: (value) =>
                                      TextHelper.testNombre(value),
                                  })}
                                />
                                {errors.contactApellido &&
                                  errors.contactApellido.type ===
                                    'required' && (
                                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                    <label
                                      id="contactApellido-error"
                                      className="error"
                                      htmlFor="contactApellido"
                                    >
                                      {t('validaciones.empty-value')}
                                    </label>
                                  )}
                                {errors.contactApellido &&
                                  errors.contactApellido.type ===
                                    'validate' && (
                                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                    <label
                                      id="contactApellido-error"
                                      className="error"
                                      htmlFor="contactApellido"
                                    >
                                      {t('validaciones.not-valid-value')}
                                    </label>
                                  )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row u-margin-bottom">
                        {personalData.tipoUsuario !== 2 ? (
                          <div className="col-12 col-md-4">
                            <EroskiDatePicker
                              type="default-date"
                              doAction={handleChangeBornDate}
                              defaultDate={bornDate}
                              control={control}
                              isInvalidDate={errorBornDate}
                              labelDefaultDate={t(
                                'datos.personaldata.bornDate',
                              )}
                              load={visible}
                            />
                          </div>
                        ) : (
                          ''
                        )}
                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            <label htmlFor="dni" className="control-label">
                              {t('datos.personaldata.identityNumber')}
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                <label className="hidden" htmlFor="tipo-dni">
                                  {t('datos.personaldata.identityType')}
                                </label>
                                <select
                                  className="form-control select-dni"
                                  id="tipo-dni"
                                  disabled={disabled}
                                  value={personalData.tipoDocumento}
                                  onChange={($event) => {
                                    setPersonalData({
                                      ...personalData,
                                      tipoDocumento: Number(
                                        $event.target.value,
                                      ),
                                    });
                                  }}
                                >
                                  {tiposDocumento.map((tip) => (
                                    <option
                                      selected={
                                        tip.value === personalData.tipoDocumento
                                      }
                                      value={tip.value}
                                      key={tip.value}
                                    >
                                      {tip.documento}
                                    </option>
                                  ))}
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <input
                                type="text"
                                className={`form-control u-margin-left ${
                                  errors.dni ? 'error' : ''
                                }`}
                                name="dni"
                                id="dni"
                                maxLength={
                                  MisDatosConstants.MAX_LENGTH_DOCUMENTO
                                }
                                disabled={disabled}
                                defaultValue={personalData.idDocumento}
                                onChange={($event) => {
                                  setPersonalData({
                                    ...personalData,
                                    idDocumento: $event.target.value,
                                  });
                                }}
                                ref={register({
                                  required: true,
                                  validate: (value) => validarTipoDni(value),
                                })}
                              />
                            </div>
                            {errors.dni && errors.dni.type === 'required' && (
                              // eslint-disable-next-line jsx-a11y/label-has-associated-control
                              <label
                                id="dni-error"
                                className="error"
                                htmlFor="dni"
                              >
                                {t('validaciones.empty-value')}
                              </label>
                            )}
                            {errors.dni && errors.dni.type === 'validate' && (
                              // eslint-disable-next-line jsx-a11y/label-has-associated-control
                              <label
                                id="dni-error"
                                className="error"
                                htmlFor="dni"
                              >
                                {t('validaciones.not-valid-format')}
                              </label>
                            )}
                          </div>
                        </div>
                        {personalData.tipoUsuario !== 2 ? (
                          <div className="col-12 col-md-4">
                            <div className="form-group select-wrapper u-margin-bottom">
                              <p className="control-label u-margin-bottom">
                                {t('datos.personaldata.genre')}
                              </p>
                              <div className="radio radio-inline">
                                <input
                                  type="radio"
                                  name="genero"
                                  id="hombre"
                                  value="hombre"
                                  className="form-control"
                                  readOnly
                                  onClick={() =>
                                    handleChangeGenero(MisDatosConstants.HOMBRE)
                                  }
                                  checked={
                                    personalData.genero ===
                                    MisDatosConstants.HOMBRE
                                  }
                                />
                                <label
                                  htmlFor="hombre"
                                  className="control-label"
                                >
                                  {t('datos.personaldata.male')}
                                </label>
                              </div>
                              <div className="radio radio-inline">
                                <input
                                  type="radio"
                                  name="genero"
                                  id="mujer"
                                  value="mujer"
                                  className="form-control"
                                  readOnly
                                  onClick={() =>
                                    handleChangeGenero(MisDatosConstants.MUJER)
                                  }
                                  checked={
                                    personalData.genero ===
                                    MisDatosConstants.MUJER
                                  }
                                />
                                <label
                                  htmlFor="mujer"
                                  className="control-label"
                                >
                                  {t('datos.personaldata.female')}
                                </label>
                              </div>
                            </div>
                            {errorGenero && (
                              // eslint-disable-next-line jsx-a11y/label-has-associated-control
                              <label
                                id="bornDate-error"
                                className="error misdatos-ratio-error"
                                htmlFor="bornDate"
                              >
                                {t('validaciones.empty-radio')}
                              </label>
                            )}
                          </div>
                        ) : (
                          ''
                        )}
                      </div>

                      <div className="row u-margin-bottom">
                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            <label
                              htmlFor="pais-telefono"
                              className="control-label"
                            >
                              {t('datos.personaldata.movil')}
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label
                                  className="hidden"
                                  htmlFor="pais-telefono"
                                >
                                  Selecciona el prefijo
                                </label>
                                <select
                                  id="pais-telefono"
                                  className="form-control pais-telefono"
                                  onChange={(e) => {
                                    misDatosHelper.retrievePrefijoByCountry(
                                      e,
                                      'movil',
                                      prefijosPaises,
                                      personalData,
                                      setPrefijoMovil,
                                      setPrefijoSec,
                                      setTamTelfMovil,
                                      setTamTelfSec,
                                      setPersonalData,
                                    );
                                    triggerValidation('paisTelefonoMovil');
                                  }}
                                >
                                  {prefijosPaises &&
                                    isFullPrefijoPrincipal &&
                                    prefijosPaises.map((c) =>
                                      misDatosHelper.logicaPrefijos(
                                        c,
                                        personalData,
                                      ) ? (
                                        <option
                                          selected={
                                            personalData.telefono === ''
                                              ? c.id ===
                                                MisDatosConstants.FLAG_NUMBER_ACTIVO
                                              : c.id ===
                                                Number(
                                                  personalData.prefijoTelefono,
                                                )
                                          }
                                          value={c.id}
                                          key={c.id}
                                        >
                                          {c.prefijo}
                                        </option>
                                      ) : (
                                        ''
                                      ),
                                    )}
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <input
                                type="text"
                                className={`form-control u-margin-left ${
                                  errors.paisTelefonoMovil ? 'error' : ''
                                }`}
                                name="paisTelefonoMovil"
                                id="pais-telefono-movil"
                                maxLength={tamTelfMovil}
                                defaultValue={personalData.telefono}
                                onChange={($event) => {
                                  setPersonalData({
                                    ...personalData,
                                    telefono: $event.target.value,
                                  });
                                  setTelfMovil($event.target.value);
                                }}
                                ref={register({
                                  required: true,
                                  validate: (value) =>
                                    misDatosHelper.testTelefono(
                                      `pais-telefono`,
                                      value,
                                    ),
                                })}
                              />
                            </div>
                            {errors.paisTelefonoMovil &&
                              errors.paisTelefonoMovil.type === 'required' && (
                                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                <label
                                  id="paisTelefonoMovil-error"
                                  className="error"
                                  htmlFor="paisTelefonoMovil"
                                >
                                  {t('validaciones.empty-value')}
                                </label>
                              )}
                            {errors.paisTelefonoMovil &&
                              errors.paisTelefonoMovil.type === 'validate' && (
                                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                <label
                                  id="paisTelefonoMovil-error"
                                  className="error"
                                  htmlFor="paisTelefonoMovil"
                                >
                                  {t(
                                    misDatosHelper.prefixErrorValidation(
                                      prefijoMovil,
                                    ),
                                  )}
                                </label>
                              )}
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group select-wrapper u-margin-bottom">
                            <label
                              htmlFor="pais-telefono-sec"
                              className="control-label"
                            >
                              {t('datos.personaldata.phone2')}
                            </label>
                            <div className="u-display-flex">
                              <div className="form-control-block form-control--compound">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label
                                  className="hidden"
                                  htmlFor="pais-telefono-sec"
                                >
                                  Selecciona el prefijo
                                </label>
                                <select
                                  id="pais-telefono-sec"
                                  className="form-control pais-telefono"
                                  onChange={(e) => {
                                    misDatosHelper.retrievePrefijoByCountry(
                                      e,
                                      'secundario',
                                      prefijosPaises,
                                      personalData,
                                      setPrefijoMovil,
                                      setPrefijoSec,
                                      setTamTelfMovil,
                                      setTamTelfSec,
                                      setPersonalData,
                                    );
                                    triggerValidation('paisTelefonoSecundario');
                                  }}
                                >
                                  {prefijosPaises &&
                                    isFullPrefijoSec &&
                                    prefijosPaises.map((c) =>
                                      misDatosHelper.logicaPrefijos(
                                        c,
                                        personalData,
                                      ) ? (
                                        <option
                                          selected={
                                            personalData.telefonoSecundario ===
                                            ''
                                              ? c.id ===
                                                MisDatosConstants.FLAG_NUMBER_ACTIVO
                                              : c.id ===
                                                Number(
                                                  personalData.prefijoTelefonoSecundario,
                                                )
                                          }
                                          value={c.id}
                                          key={c.id}
                                        >
                                          {c.prefijo}
                                        </option>
                                      ) : (
                                        ''
                                      ),
                                    )}
                                </select>
                                <div className="icon icon-small">
                                  <IconChat />
                                </div>
                              </div>
                              <input
                                type="text"
                                className={`form-control u-margin-left ${
                                  errors.paisTelefonoSecundario ? 'error' : ''
                                }`}
                                name="paisTelefonoSecundario"
                                id="pais-telefono-secundario"
                                maxLength={tamTelfSec}
                                defaultValue={personalData.telefonoSecundario}
                                onChange={($event) => {
                                  setPersonalData({
                                    ...personalData,
                                    telefonoSecundario: $event.target.value,
                                  });
                                }}
                                ref={register({
                                  validate: (value) =>
                                    misDatosHelper.testTelefono(
                                      `pais-telefono-sec`,
                                      value,
                                      true,
                                    ),
                                })}
                              />
                            </div>
                            {errors.paisTelefonoSecundario &&
                              errors.paisTelefonoSecundario.type ===
                                'validate' && (
                                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                <label
                                  id="paisTelefonoSecundario-error"
                                  className="error"
                                  htmlFor="paisTelefonoSecundario"
                                >
                                  {t(
                                    misDatosHelper.prefixErrorValidation(
                                      prefijoSec,
                                      true,
                                    ),
                                  )}
                                </label>
                              )}
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group">
                            <label htmlFor="email" className="control-label">
                              {t('datos.personaldata.email')}
                            </label>
                            <div className="form-control-block">
                              <input
                                type="email"
                                className={`form-control ${
                                  errors.email ? 'error' : ''
                                }`}
                                name="email"
                                id="email"
                                maxLength={MisDatosConstants.MAX_LENGTH_EMAIL}
                                defaultValue={personalData.emailContacto}
                                onChange={($event) => {
                                  setPersonalData({
                                    ...personalData,
                                    emailContacto: $event.target.value,
                                  });
                                }}
                                ref={register({
                                  required: true,
                                  // eslint-disable-next-line no-useless-escape
                                  pattern: misDatosHelper.getExpresionRegularEmail(),
                                  validate: {
                                    valid: (value) =>
                                      misDatosHelper.isAsciiPrintableEmail(
                                        value,
                                      ),
                                    corporativeMail: (value) =>
                                      misDatosHelper.isCorporativeEmail(value),
                                  },
                                })}
                              />
                              {errors.email &&
                                errors.email.type === 'required' && (
                                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                  <label
                                    id="email-error"
                                    className="error"
                                    htmlFor="email"
                                  >
                                    {t('validaciones.empty-value')}
                                  </label>
                                )}
                              {errors.email && errors.email.type === 'pattern' && (
                                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                <label
                                  id="email-error"
                                  className="error"
                                  htmlFor="email"
                                >
                                  {t('validaciones.not-valid-email')}
                                </label>
                              )}
                              {errors.email && errors.email.type === 'valid' && (
                                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                <label
                                  id="email-error"
                                  className="error"
                                  htmlFor="email"
                                >
                                  {t('validaciones.not-valid-value')}
                                </label>
                              )}
                              {errors.email &&
                                errors.email.type === 'corporativeMail' && (
                                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                  <label
                                    id="email-error"
                                    className="error"
                                    htmlFor="email"
                                  >
                                    {t('validaciones.corporative-mail')}
                                  </label>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {(() => {
                        if (
                          personalData.tipoUsuario !==
                            MisDatosConstants.ID_TIPO_USUARIO_GIBRALTAR ||
                          (personalData.tipoUsuario ===
                            MisDatosConstants.ID_TIPO_USUARIO_GIBRALTAR &&
                            dataUser.user.titular === false)
                        ) {
                          return (
                            <div
                              className="row u-margin-bottom"
                              style={{ justifyContent: 'start' }}
                            >
                              <div className="col-12 col-md-4">
                                <div className="form-group select-wrapper">
                                  <label
                                    className="control-label"
                                    htmlFor="idioma-comunica"
                                  >
                                    {t('datos.personaldata.language2')}
                                  </label>
                                  <div className="form-control-block">
                                    <select
                                      className="form-control"
                                      id="idioma-comunica"
                                      value={personalData.idiomaComunicacion}
                                      onChange={($event) => {
                                        setPersonalData({
                                          ...personalData,
                                          idiomaComunicacion:
                                            $event.target.value,
                                        });
                                      }}
                                    >
                                      {idiomas &&
                                        idiomas.map((idi) => {
                                          return (
                                            <option
                                              key={idi}
                                              selected={
                                                idi ===
                                                personalData.idiomaComunicacion
                                              }
                                              value={idi}
                                            >
                                              {misDatosHelper.getLiteralIdiomasFromIdEco(
                                                idi,
                                              )}
                                            </option>
                                          );
                                        })}
                                    </select>
                                    <div className="icon icon-small">
                                      <IconChat />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                        return false;
                      })()}

                      {(() => {
                        if (isFamilyData && !isAditional && isTitular) {
                          return (
                            <div
                              className="row u-margin-bottom"
                              style={{ paddingTop: '15px' }}
                            >
                              <div className="col-12 col-md-4">
                                <fieldset>
                                  <label
                                    className={`checkgroup ${
                                      isValidFamilia ? 'disabled' : ''
                                    }`}
                                    htmlFor="isfamily"
                                  >
                                    {t('datos.personaldata.family')}
                                    <input
                                      type="checkbox"
                                      id="isfamily"
                                      disabled={isValidFamilia}
                                      className="form-control"
                                      checked={isInfoFamily}
                                      onChange={(e) => handlerChange(e)}
                                    />
                                    <span className="checkmark" />
                                  </label>
                                </fieldset>
                              </div>
                            </div>
                          );
                        }
                        return false;
                      })()}

                      {(() => {
                        if (
                          isFamilyData &&
                          isInfoFamily &&
                          !isAditional &&
                          isTitular
                        ) {
                          return (
                            <div className="row u-margin-bottom">
                              <div className="col-12 col-md-4">
                                <div className="form-group u-margin-bottom">
                                  <label
                                    htmlFor="numerocarne"
                                    className="control-label"
                                  >
                                    {t('datos.personaldata.carne')}
                                  </label>
                                  <div className="form-control-block">
                                    <InputMask
                                      mask="99/999999/9999"
                                      alwaysShowMask
                                      disabled={isValidFamilia}
                                      value={familiarData.numeroCarnet}
                                      className={`form-control ${
                                        errorCarnet ? 'error' : ''
                                      }`}
                                      name="numerocarne"
                                      id="numerocarne"
                                      onChange={($event) => {
                                        handlerCarnetChange(
                                          $event.target.value,
                                          MisDatosConstants.MAX_LENGTH_CARNE,
                                        );
                                      }}
                                      ref={register({
                                        required: false,
                                        // eslint-disable-next-line no-useless-escape
                                        validate: (value) =>
                                          misDatosHelper.testCarnet(
                                            value,
                                            MisDatosConstants.MAX_LENGTH_CARNE,
                                            false,
                                          ),
                                      })}
                                    />
                                    {errorCarnet && (
                                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                      <label
                                        id="numerocarne-error"
                                        className="error"
                                        htmlFor="numerocarne"
                                      >
                                        {t(
                                          'validaciones.validate-carnet-error',
                                        )}
                                      </label>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-md-4">
                                <div className="form-group u-margin-bottom">
                                  <div className="form-control-block">
                                    <CapraboDatePicker
                                      doAction={handleChangeTerminateDate}
                                      control={control}
                                      defaultDate={terminateDate}
                                      endDate={endTerminateDate}
                                      isInvalidDate={errorTerminateDate}
                                      labelDefaultDate={t(
                                        'datos.personaldata.expirationDate',
                                      )}
                                      load={visible}
                                      dateDisabled={isValidFamilia}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                        return false;
                      })()}

                      <div className="u-text-right">
                        <button
                          id="datos-personales-submit-btn"
                          type="submit"
                          className={`btn btn-primary ${
                            isSubmitting ? 'btn__disable' : ''
                          }`}
                        >
                          {t('datos.personaldata.update')}
                        </button>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </section>
              <ServicioSms
                startService={startSmsService}
                setStartSmsService={setStartSmsService}
                opcion={opcion}
                setShowPersonalData={setShow}
                prefijosPaises={prefijosPaises}
                cargarPersonalData={cargarPersonalData}
                cargarAccessData={cargarAccessData}
                prefijoPersonalData={prefijoMovil}
                telefonoPersonalData={telfMovil}
                origenData={opcion}
              />
              <ModalConfirmacion
                isBig={false}
                isSmall={false}
                textCentered
                showModal={emailContactoCambiado}
                setShowModal={setEmailContactoCambiado}
                title={t(title)}
                textHTMLContent={textForModalCambioEmail}
                doClose={emptymethod}
                doAceptar={emptymethod}
                showCancel={false}
                acceptButtonTextKey={acceptButtonTextKey}
              />
              <ModalContactConfirmacion
                isBig={false}
                isSmall
                textCentered
                showModal={ShowErrorSinTransicion}
                setShowModal={setShowErrorSinTransicion}
                title={errorTitulo}
                textHTMLContent={errorMensaje}
                doClose={cancelButtonEvent}
                doAceptar={ducplicateDocumentEvent}
                hideXButton={false}
                showCancel={showCancelButton}
                acceptButtonTextKey={acceptContactButtonTextKey}
                cancelButtonTextKey={cancelContactButtonTextKey}
                event_hittype="event"
                event_category="CTA"
                event_action="MIS-DATOS"
                event_label="DI-DUPLICADO"
              />
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default DatosForm;
